<template>
  <div :class="contentClass ? 'content-root-center' : 'content-root'" @mouseleave="showPopup = false">
    <div class="container-fluid override">
      <div class="row">
        <div
          :id="task.id"
          class="tags-btn col-md-7"
          :class="{
            'btn-tag-for-more-then-three': measureIt(task.categories),
            'tags-btn': measure
          }"
        >
          <div
            :id="'btnCarousel' + task.id"
            class="carousel slide"
            data-ride="carousel"
            data-interval="false"
          >
            <!-- Indicators -->
            <!--              <ol class="carousel-indicators">-->
            <!--                <li data-target="#myCarousel" data-slide-to="0" class="active"></li>-->
            <!--                <li data-target="#myCarousel" data-slide-to="1"></li>-->
            <!--                <li data-target="#myCarousel" data-slide-to="2"></li>-->
            <!--              </ol>-->

            <!-- Wrapper for buttons -->
            <div class="carousel-inner">
              <div
                class="item"
                v-for="(taskGroup, idx) in tagsGroupArray"
                :key="idx"
                :class="{
                  active: idx == 0
                }"
              >
                <button
                  class="btn btn-warning btn-tag itemBtn"
                  v-for="tag in sortCatByLength(taskGroup)"
                  @click="fillterTags(tag.id)"
                  :key="tag.id"
                  :class="{
                    'btn-danger': tag.id === 35 || tag.id === 211
                  }"
                >
                  {{ tag.cat_type }}
                </button>
              </div>
            </div>

            <!-- Left and right controls -->
            <a
              class="left carousel-control"
              :href="'#btnCarousel' + task.id"
              data-slide="prev"
              v-if="tagsGroupArray.length > 1"
            >
              <i class="fas fa-angle-left"></i>
            </a>
            <a
              class="right carousel-control"
              :href="'#btnCarousel' + task.id"
              data-slide="next"
              v-if="tagsGroupArray.length > 1"
            >
              <i class="fas fa-angle-right"></i>
            </a>
          </div>

          <!--          <button-->
          <!--            class="btn btn-warning btn-tag itemBtn"-->
          <!--            v-for="(tag, idx) in sortCatByLength(task.categories)"-->
          <!--            @click="fillterTags(tag.id)"-->
          <!--            :key="tag.id"-->
          <!--            v-if="tagsContainerOverflow ? idx < 3 : idx < 6"-->
          <!--            :class="{-->
          <!--              'btn-danger': tag.id === 35 || tag.id === 211-->
          <!--            }"-->
          <!--          >-->
          <!--            {{ tag.cat_type }}-->
          <!--          </button>-->
        </div>
        <div :class="taskClasses">
          <button
            class="btn read-btn btn-block"
            :class="
              getClassforOpenBtn(selectedMainTab, taskInCheckProgress, task)
            "
            @mouseenter="openPopup"
            @click="

              // getReplies();
             getLastReply() === 'Email Replayed...'   || getLastReply() === 'Email Sent...' ? sendTaskObj() : openMainTaskWindow();
              $emit('show_assign_inp', task);

            "
          >
            <span class="pull-left" v-if="wordFilter.length < 4">{{
                getLastReply() === 'Email Replayed...'   || getLastReply() === 'Email Sent...' ? getLastReplyForEmail() : getLastReply() | truncate(30)
            }}</span>
            <span
              class="pull-left"
              v-if="wordFilter.length > 3"
              v-html="getKeyWordInContent()"
              >... ...</span
            >
            <!--            <span class="pull-left">{{ removeHtml(content) | truncate(65) }}</span>-->

            <!--                      {{ removeHtml(content) | truncate(65) }}-->
          </button>
        </div>

        <!--        <div v-if="openTheRest" class="forTheRestCat" v-click-outside="closeIt">-->
        <!--          <button-->
        <!--            class="btn allRestCat"-->
        <!--            v-for="t in task.categories.slice(3, task.categories.length)"-->
        <!--            @click="fillterTags(t.cat_id)"-->
        <!--            :key="t.cat_id"-->
        <!--          >-->
        <!--            {{ t.category.cat_type }}-->
        <!--          </button>-->
        <!--        </div>-->
        <!--        <div class="col-sm-5 content-preview">-->
        <!--          {{ removeHtml(content) | truncate(40) }}-->
        <!--        </div>-->
      </div>
    </div>
    <!--      <span v-for="tag in task.categories" :key="tag.cat_id">{{ tag.cat_type.cat_type }}</span>-->
    <transition name="fade">
      <main-task-window
        @clear_sets="clearReplySets"
        id="main-task-window"
        v-if="replyMode"
        v-click-outside="closeMainTaskWindow"
        :mode="mode"
        :task="task"
        v-on:closeMainTaskWindow="closeMainTaskWindow"
        :selectedTaskTab="selectedMainTab"
        :assign-reply-to="assignReplyTo"
      ></main-task-window>
    </transition>
    <transition name="fade">
      <div
        v-if="showPopup"
        class="task-preview-popup"
        @mouseleave="showPopup = false"
      >
        <div class="task-content-preview">
          <div class="f-item replies-preview" v-if="replies.length > 0">
            <div>
              <table class="table-sm table-bordered replies-table">
                <tbody>
                  <template
                    :id="'selectUser-' + record.user.id"
                    v-for="record in replies"
                  >
                    <tr :key="record.id + 1">
                      <td
                        class="td-content ql-editor"
                        v-html="record.content"
                        colspan="7"
                      ></td>
                    </tr>
                    <tr :key="record.id">
                      <td class="td-date">
                        {{ record.updated_at | shortDate }}
                      </td>
                      <td class="td-time">
                        {{ record.updated_at | shortTime }}
                      </td>

                      <template>
                        <td class="td-from">{{ record.user.full_name }}</td>
                        <td class="td-to">
                          {{ getUserReplyTo(record.reply_assignment) }}
                        </td>
                      </template>

                      <td class="td-process">
                        {{ getTaskSubStatusByUser(record.reply_by) }}
                      </td>
                      <td class="td-timer">
                        {{ getTimeReply(record.created_at) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr class="bg-primary">
                    <th scope="col">Date</th>
                    <th scope="col">Time</th>
                    <template>
                      <th scope="col">From</th>
                      <th scope="col">To</th>
                    </template>

                    <th scope="col">Process</th>
                    <th scope="col">Time</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="f-item task-preview">
            <div id="task-preview" class="task-preview-div">
              <TaskPreview :content="task.content"/>
            </div>
<!--            <vue-editor-->
<!--              id="task-preview-editor"-->
<!--              :disabled="true"-->
<!--              useCustomImageHandler-->
<!--              v-model="task.content"-->
<!--              :editorOptions="taskPreviewEditorSettings"-->
<!--            />-->
          </div>
        </div>
      </div>
    </transition>
    <div id="imgModal" class="modal">
      <span class="close-img-modal">&times;</span>
      <!--      <button type="button" class="close" data-dismiss="imgModal">&times;</button>-->

      <img class="modal-content" id="img01" />
    </div>
  </div>
</template>
<script>
import { VueEditor, Quill } from "vue2-editor";

import TaskPreview from "./TaskPreview.component"; //kobi

import vClickOutside from "v-click-outside";
import UsersActiveScope from "../../company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import { mapActions, mapGetters, mapState } from "vuex";
import MainTaskWindow from "./MainTaskWindow.component";
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import SocketEndpoints from "@/mixins/system/SocketEndpoints";
export default {
  name: "TaskContent",
  mixins: [UsersActiveScope, SocketEndpoints],
  components: {
    MainTaskWindow,
    TaskPreview
    // VueEditor
  },
  props: {
    contentClass: {
      required: false,
      type: Boolean
    },
    imageOpening: {
      type: Boolean
    },
    turnOff: {
      type: Boolean,
    },
    taskOpenedFromImg:{
      type: Number,
    },
    isClicked: {
      type: Boolean
    },
    preOpenTaskFromChart: {
      type: Boolean
    },
    preOpenMeetingFromMsgCenter: {
      type: Boolean
    },
    task: {
      type: Object,
      required: true
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    wordFilter: {
      type: String
    },
    assignReplyTo: {
      type: Array,
      default: () => []
    },
    replyStatus: {
      type: Array,
      default: () => ({
        id: 1,
        type: "REPLY",
        title: "Replied"
      })
    },
    queryObject: {
      type: Object
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading"
    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "taskDictionaries",
      "categories"
    ]),

    ...mapGetters("tasks", ["getTasks", "getActiveTasks", "getAllActiveTasks"])
  },

  data() {
    return {
      taskClasses: ['task-btn-open-wrapper', 'col-md-5'],
      tagsFontWidth: 7,
      maxTagsContainerWidth: 350,
      tagsGroupArray: [],
      CheckIfAllReplied: false,
      creatorHasConfirmedTheTask: false,
      countActiveTasks: [],
      editorConfig: {
        fullPage: false,
        resize_enabled: false
        // removePlugins: 'resize,autogrow',
      },
      replies: [],
      showPopup: false,
      showBtnBar: false,
      content: this.task.content,
      showPencil: false,
      showEditTaskText: false,
      showEditTask: false,
      showReplyTaskText: false,
      reply: null,
      showReply: false,
      taskReplies: [],
      taskRepliesForCheck: [],
      showFullContent: false,
      userConfirmed: false,
      showReplyPopup: false,
      isImgModalOpened: false,
      taskInCheckProgress: false,
      taskPreviewEditorSettings: {
        theme: "bubble",

        modules: {
          toolbar: {
            container: [
              // [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              // ["bold", "italic", "underline"], // toggled buttons
              // [{ align: "" }, { align: "right" }, { align: "justify" }],
              // ["blockquote"],
              // [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              // ["link", "image", "video"]
              // ["clean"] // remove formatting button
            ],
            handlers: {
              video: () => {
                // just give your custom elements a class like "ql-customThingy" and the handlers will just work
              },
              redo: () => {}
            }
          },
          // imageResize: { displaySize: true },
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: [
              " ",
              "#",
              "anal",
              "anus",
              "arse",
              "ass",
              "ballsack",
              "balls",
              "bastard",
              "bitch",
              "biatch",
              "bloody",
              "blowjob",
              "bollock",
              "bollok",
              "boner",
              "boob",
              "bugger",
              "bum",
              "butt",
              "buttplug",
              "clitoris",
              "cock",
              "coon",
              "crap",
              "cunt",
              "damn",
              "dick",
              "dildo",
              "dyke",
              "fag",
              "feck",
              "fellate",
              "fellatio",
              "felching",
              "fuck",
              "fudgepacker",
              "flange",
              "goddamn",
              "hell",
              "homo",
              "jizz",
              "knobend",
              "labia",
              "muff",
              "nigger",
              "nigga",
              "jude",
              "penis",
              "piss",
              "poop",
              "prick",
              "pube",
              "pussy",
              "queer",
              "scrotum",
              "sex",
              "shit",
              "sh1t",
              "slut",
              "smegma",
              "spunk",
              "suck",
              "tit",
              "tosser",
              "turd",
              "twat",
              "vagina",
              "wank",
              "whore",
              "wtf"
            ],
            defaultMenuOrientation: "top",
            // offsetTop: 0,
            // offsetLeft:2,
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              // let x = mentionChar.toLowerCase()
              if (mentionChar === "#") {
                values = this.hashValues;
                if (searchTerm.length === 0) {
                  renderList(values, searchTerm);
                } else {
                  const matches = [];
                  for (let i = 0; i < values.length; i++)
                    if (
                      ~values[i].value
                        .toLowerCase()
                        .indexOf(searchTerm.toLowerCase())
                    )
                      matches.push(values[i]);
                  if (matches.length > 0) {
                    renderList(matches, searchTerm);
                  } else {
                    let tempTag = {
                      denotationChar: "#",
                      id: "777",
                      index: "123",
                      value: searchTerm
                    };
                    matches.push(tempTag);
                    renderList(matches, searchTerm);
                  }
                }
              } else if (mentionChar === " ") {
              } else {
                setTimeout(() => {
                  // this.textValidation(this.taskTextFromLocal);
                }, 1000);
                mentionChar = null;
              }
            },
            onOpen: () => {},
            onSelect: async (item, insertItem) => {
              await this.addNewTagFromEditor(item.value);
              if (item.denotationChar === "#") {
                insertItem(item);
                let tempCategory = this.categoriesForMention.filter(
                  category => {
                    return category.value == item.value;
                  }
                );
                // if (this.selectedEditorTab == "MT" ||this.selectedEditorTab == "TASK") {
                if (
                  !this.newTask.cat_arr.some(category => {
                    //          checks if category already in array
                    return category.value == tempCategory[0].value;
                  })
                ) {
                  this.newTask.cat_arr.push(tempCategory[0]); // insert category from editor to new task object
                }
                // } else {
                //   this.subTasks.forEach(subTask => {
                //     if (this.selectedEditorTab == subTask.subTaskTab) {
                //       if (
                //         !subTask.subTaskCategory.some(category => {
                //           //          checks if category already in array
                //           return category.value == tempCategory[0].value;
                //         })
                //       ) {
                //         subTask.subTaskCategory.push(tempCategory[0]);
                //       }
                //     }
                //   });
                // }
                this.componentKeyTags += 1;
              } else if (item.denotationChar === "@") {
                insertItem(item);
                let subTask_id = this.selectedEditorTab.substr(
                  this.selectedEditorTab.length - 1
                );
                let subTaskUser = await this.salesPersonList.find(user => {
                  return user.full_name == item.value;
                });

                // this.subTasks[
                //   `subTask_${subTask_id}`
                // ].subTaskUserAssignment.push(subTaskUser);
              }
            }
          }
        },
        disabled: true
      },
      inEditReplyOperation: false,
      inEditTaskOperation: false,
      selectedReplyIdToUpdate: null,
      updatedReply: null,
      replyToSpecificUsers: [],
      remainingToBeConfirmed: null,
      transferToUsersList: null,
      showTransferToUsersResults: false,
      searchTransferToUserNameQuery: null,
      searchTransferToUserNameQueryResult: [],
      transferToThisUser: [],
      transferredTasks: [],
      transferToButtonText: "TRANSFER TASK TO",
      transferTaskTo: false,
      replyMode: false,
      mode: "reply",
      selectedTaskTabForReply: "TASK",
      openTheRest: false,
      measure: null,
      meijer: null,
      tagsContainerWidth: 0,
      tagsContainerOverflow: false
    };
  },
  mounted() {
    if (this.task) {
      if(this.taskOpenedFromImg && this.task.id ===this.taskOpenedFromImg){
        this.replyMode = true
      }
      this.checkIfTaskInCheckProgress();
      this.getRepliesForAuthUser();
      // this.setOnclickToImg()
      this.showPopup = this.preOpenTaskFromChart;
      this.replyMode = this.preOpenMeetingFromMsgCenter;
      this.$root.$on("task-preview-popup-opened", data => {
        if (data !== this.task.id) {
          this.showPopup = false;
        }
      });
      this.prepareTagsArray(this.task.categories);
      this.tagsContainerWidth = $(`#${this.task.id}`).width();
      if ($(`#${this.task.id}`).width() > 415) {
        this.tagsContainerOverflow = true;
      }
    }

    if(this.turnOff){
      this.taskClasses.push('d-none');
    }
  },
  beforeDestroy() {
    // this.$root.$off("task-preview-popup-opened");
  },
  watch: {
    imageOpening: function(){
      if(this.imageOpening){
        this.openMainTaskWindow();
        this.$emit('show_assign_inp', this.task)
      }
    },
       preOpenTaskFromChart: function() {
      if (this.preOpenTaskFromChart) {
        let tasksElements = $(".td-task-content");
        this.showPopup = true;
      }
    },
    preOpenMeetingFromMsgCenter: function() {
      if (this.preOpenMeetingFromMsgCenter) {
        this.replyMode = true;
      }
    },
    taskOpenedFromImg: function (){
      if(this.taskOpenedFromImg && this.task.id ===this.taskOpenedFromImg){
        this.replyMode = true
      }
    }
  },
  methods: {
    getTagsWidth(tags) {
      let allTagsWidth = 0;
      tags.forEach(e => {
        allTagsWidth += e.category.cat_type.length;
      });
      return allTagsWidth;
    },
    // groupTagsByWidth(tags) {
    //   let startTagsArray = tags;
    //   let tempTagsArray = [];
    //   let allTagsWidth = this.getTagsWidth(startTagsArray);
    //   let tempArrayTagsWidth = this.getTagsWidth(tempTagsArray);
    //
    //   do {
    //     const firstElement = startTagsArray.shift();
    //     tempTagsArray.push(firstElement);
    //     let tempArrayTagsWidth = this.getTagsWidth(tempTagsArray);
    //     if (tempArrayTagsWidth * this.tagsFontWidth >= this.maxTagsContainerWidth) {
    //       this.tagsGroupArray.push(tempTagsArray);
    //       tempTagsArray = [];
    //     }
    //     // if(tempArrayTagsWidth * 7 < 300){
    //     //   tempTagsArray.push(firstElement)
    //     // } else{
    //     //   this.tagsGroupArray.push(tempTagsArray)
    //     //   tempTagsArray = []
    //     //   tempTagsArray.push(firstElement)
    //     // }
    //     allTagsWidth = this.getTagsWidth(startTagsArray) * this.tagsFontWidth;
    //   } while (allTagsWidth * this.tagsFontWidth > this.maxTagsContainerWidth);
    //   // if(tempTagsArray.length > 0){
    //   //   this.tagsGroupArray.push(tempTagsArray)
    //   // }
    //
    //   // while (allTagsWidth * 7 > 300) {
    //   //   const firstElement = startTagsArray.shift();
    //   //   if(tempArrayTagsWidth * 7 < 300){
    //   //     tempTagsArray.push(firstElement)
    //   //   } else{
    //   //     this.tagsGroupArray.push(tempTagsArray)
    //   //     tempTagsArray = []
    //   //     tempTagsArray.push(firstElement)
    //   //   }

    //   //
    //   //
    //   //
    //   //   allTagsWidth = allTagsWidth - 20;
    //   // }
    // },
    groupTagsByWidth(tags) {
      let tempArray = [];
      tags.forEach((tag, idx) => {
        if (
          (this.getTagsWidth(tempArray) + this.getTagsWidth([tag])) * 7 <
          this.maxTagsContainerWidth
        ) {

          tempArray.push(tag);
          if (idx === tags.length - 1) {
            this.tagsGroupArray.push(tempArray);
          }
        } else {
          this.tagsGroupArray.push(tempArray);
          tempArray = [];
          tempArray.push(tag);
        }
      });
      // this.tagsGroupArray.push(tempArray);
    },
    prepareTagsArray(tags) {
      let allTagsWidth = this.getTagsWidth(tags);
      let containerWidth = allTagsWidth * this.tagsFontWidth;
      if (containerWidth > this.maxTagsContainerWidth) {
        this.groupTagsByWidth(tags);
      } else {
        this.tagsGroupArray = [tags];
      }
    },
    checkIfTaskIsViewed(task) {
      let viewsNotThisUser = task.task_view_log.filter(item => {
        return item.user_id !== this.getOriginalCreator();
      });
      if (viewsNotThisUser.length < 1) {
        return true;
      } else {
        return false;
      }
    },
    getClassforOpenBtn(selectedMainTab, taskInCheckProgress, task) {
      if (selectedMainTab === "completed") {
        return "btn-success";
      } else {
        if (taskInCheckProgress) {
          return "btn-warning";
        } else {
          // return 'btn-
          // if(task.task_view_log.length < 1){
          if (this.checkIfTaskIsViewed(task)) {
            return "btn-info";
          } else {
            return "btn-danger";
          }
        }
      }
    },
    setOnclickToImg() {
      // let images = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("IMG");
      let images = document
        .getElementsByClassName("task-preview-popup")[0]
        .getElementsByTagName("IMG");
      images.forEach(img => {
        img.setAttribute("class", "img-editor");
        img.style.cursor = "pointer";
        img.onclick = function() {
          let modal = document.getElementById("imgModal");
          let modalImg = document.getElementById("img01");
          modal.style.display = "block";
          modalImg.src = this.src;

          let span = document.getElementsByClassName("close-img-modal");

          for (let item of span) {
            item.onclick = function() {
              modal.style.display = "none";
            };
          }
        };
      });
    },

    openPopup() {
      this.showPopup = true;
      this.$root.$emit("task-preview-popup-opened", this.task.id);
      // console.log('kobi popup')
      // this.setOnclickToImg();
    },
    getTimeReply(time) {
      // let duration = moment.duration(moment(this.task.created_at).diff(time));
      let duration = moment.duration(moment(time).diff(this.task.created_at));
      // let hours = duration.asHours();
      let hours = duration.humanize();
      return hours;
    },
    getTaskSubStatusByUser(userId) {
      let userSubStatus = this.task.taskSubStatus.find(item => {
        return item.user_id == userId;
      });
      if (userSubStatus && userSubStatus.task_sub_status_type) {

        return userSubStatus.task_sub_status_type.title;
      } else {
        return "Default";
      }
    },
    getUserReplyTo(replyTo) {
      let korsy = replyTo.find(item => {
        return item.assigned_by != item.assigned_to.id;
      });
      if (korsy) {
        return korsy.assigned_to.full_name;
      }
    },

    async getRepliesForAuthUser() {
      let replies = [];
      await this.task.reply.forEach(item => {
        item.reply_assignment.forEach(repItem => {
          if (repItem.assigned_to.id === this.auth.user.id) {
            replies.push(item);
          }
        });
      });
      // this.task.reply = replies;
      // this.replies = replies;
      this.replies = this.task.reply;
    },

    insertAndShift(arr, from, to) {
      let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
      arr.splice(to, 0, cutOut); // insert it at index 'to'
      return arr;
    },
    sortCatByLength(cats) {
      var tempArr = [];

      cats.forEach(e => {
        tempArr.push(e.category.cat_type);
      });
      tempArr = tempArr.sort((a, b) => {
        return b.length - a.length;
      });
      if (!jQuery.isEmptyObject(this.queryObject) && this.queryObject.tag_id.length > 0) {
        for (const [i, value] of this.queryObject.tag_id.entries()) {
          let NameOfTag = cats.filter(i => i.category.id === value);
          if (NameOfTag.length > 0) {
            NameOfTag = NameOfTag[0].category.cat_type;
            let oldPose = tempArr.indexOf(NameOfTag);
            tempArr = this.insertAndShift(tempArr, oldPose, i);
          }
        }
      }
      let tempArr2 = [];
      tempArr.forEach(e => {
        let tempId = cats.filter(i => i.category.cat_type === e);
        tempArr2.push({
          id: tempId[0].category.id,
          cat_type: tempId[0].category.cat_type
        });
      });

      return tempArr2;
    },
    measureIt(cats) {
      let allBtnsSize = 0;
      // let allBtns=document.getElementById(this.task.id).getElementsByClassName("itemBtn");
      cats.forEach(e => {
        allBtnsSize += e.category.cat_type.length;
      });
      if (allBtnsSize > 30) {
        this.measure = true;
        return this.measure;
      } else {
        this.measure = false;
        return this.measure;
      }
      //     // allBtns.forEach(e=>{allBtnsSize+=e.clientWidth})
      //     //
      //     // if(allBtnsSize > 187){
      //     //   this.measure = true
      //     // }else {
      //     //   this.measure = false
      //     // }
    },

    // meijerIt(){
    //   let allBtnsSize=0;
    //   let allBtns=document.getElementById(this.task.id).getElementsByClassName("itemBtn");
    //
    //   allBtns.forEach(e=>{allBtnsSize+=e.clientWidth})
    //   if(allBtnsSize > 187){
    //     this.meijer = true
    //   }else {
    //     this.meijer = false
    //   }
    // },
    sendTaskObj(){
      this.$store.commit("tasks/SetOpenRepForEmails", this.task);
    },
    getLastReplyForEmail(){
      let lastReply = this.removeHtml(this.task.content);
      if(lastReply.includes("Subject")){
        lastReply = lastReply.split("Re:").pop();
      }
      return lastReply;
    },
    getLastReply() {

      let lastReply = this.removeHtml(this.task.reply[0].content);
      return lastReply.length > 0 ? lastReply + "..." : "Open task";
      // return this.removeHtml("content")
    },
    getKeyWordInContent() {

      let content = this.removeHtml(this.task.content);
      let index = content.search(this.wordFilter);
      let sentence = `...${content.substring(index - 12, index + 45)}...`;
      let temp = sentence.replace(
        this.wordFilter,
        `<span style="font-weight: 700">${this.wordFilter}</span>`
      );
      return temp;
    },
    checkIfTaskInCheckProgress() {
      let isInCheck = this.task.task_check.some(
        user => user.requested_check === this.auth.user.id
      );
      this.taskInCheckProgress = isInCheck;
    },
    clearReplySets() {
      this.$emit("clear_sets");
    },
    btnTitle(timeDuration) {
      let subStat = null;
      if (this.task.taskSubStatus.length) {
        subStat = this.task.taskSubStatus.find(
          user => user.user_id === this.auth.user.id
        );
      }

      if (subStat.task_sub_status_type.id === 6) {
        return "WA";
      } else {
        if (timeDuration.length > 0) {
          let timer = timeDuration.find(item => {
            return item.user_id == this.auth.user.id;
          });
          if (timer) {
            if (timer.running == 0) {
              return "Read...";
            } else {
              return "WIP";
            }
          } else {
            return "Read...";
          }
        } else {
          return "Read...";
        }
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    closeIt() {
      this.openTheRest = false;
    },
    closeMainTaskWindow() {
      if (
        event.target.className == "v-cal-dialog-card__header" ||
        event.target.className == "v-cal-dialog__title" ||
        event.target.className == "v-cal-input" ||
        event.target.className == "v-cal-input " ||
        event.target.className == "v-cal-input-group" ||
        event.target.className == "v-cal-dialog-card__footer" ||
        event.target.className == "v-cal-dialog__close" ||
        event.target.className == "v-cal-dialog__bg" ||
        event.target.className == "v-cal-button is-rounded is-primary" ||
        event.target.className == "v-cal-dialog-card__body" ||
        event.target.className == "v-cal-fields" ||
        event.target.className == "v-cal-label" ||
        event.target.className == "form-control" ||
        event.target.className == "select-option" ||
        event.target.className == "vue__time-picker time-picker" ||
        event.target.className == "display-time all-selected" ||
        event.target.className == "dropdown" ||
        event.target.className == "clear-btn" ||
        event.target.className == "select-list" ||
        event.target.className == "hours" ||
        event.target.className == "minutes" ||
        event.target.className == "time-picker-overlay" ||
        event.target.className == "custom-select" ||
        event.target.className == "option" ||
        event.target.className == "active" ||
        event.target.className == "btn-decline" ||
        event.target.className == "btn btn-md btn-decline" ||
        event.target.className == ""
      ) {
      } else {
        this.replyMode = false;
      }


    },

    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    ifTaskReadOnly() {
      return this.task.task_read_only.some(
        user => user.user_id === this.auth.user.id
      );
    },
    ifTaskTransferedByMe() {
      return this.task.transfer.some(
        user => user.transfer_by.id === this.auth.user.id
      );
    },
    checkUserPermissionForStartTimer() {
      if (this.task.task_sub_type.id === 6) {
        return false;
      }
      // if(this.auth.user.id !== this.getOriginalCreator() && this.auth.user.role !== 1 && this.auth.user.role !== 2){
      // if (this.auth.user.id === this.getOriginalCreator()) {
      if (
        this.auth.user.id === this.getOriginalCreator() ||
        this.ifTaskTransferedByMe()
      ) {
        return false;
      } else {
        if (this.ifTaskReadOnly()) {
          return false;
        } else {
          if (this.auth.user.role === 1 || this.auth.user.role === 2) {
            if (this.isTaskExecutor()) {
              return true;
            }
            return false;
          }
          return true;
        }
      }
    },
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });
      return originalCreator;
    },
    isTaskExecutor() {
      let isTaskExecutor = false;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === this.auth.user.id) {
          isTaskExecutor = true;
        }
      });

      return isTaskExecutor;
    },

    async openMainTaskWindow() {
      // await this.$store.dispatch("tasks/fetchAllActiveTasks");
      // await this.countActiveTasksPerUser();
      //  await this.countActiveUsersPerGroup();
      // this.$store.commit('tasks/setFetchTasks',{flag: true});

      this.saveCountUserView();
      if (
        this.task.task_type.id !== 7 &&
        this.task.task_type.id !== 2 &&
        this.selectedMainTab !== "outline"
      ) {
        if (
          this.checkUserPermissionForStartTimer() &&
          !this.taskInCheckProgress
        ) {
          this.$root.$emit("task_opened_start_working", this.task.id);
        }
      }
      if (this.task.task_type.id === 7) {
        this.mode = "reply-email";
      }
      this.replyMode = true;
      this.showPopup = false;

      const id = this.auth.user.id;

      this.msgSocket.emit("open_task_notification", {
        crm_user_id: id,
        approved: "APPROVED",
        type: "TASK",
        tag: "none",
        operation: "no",
        options: {
          task_id: this.task.id
        }
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        updatedAt: null
      });
    },
    fillterTags(tagId) {
      this.$emit("tagsFillter", tagId);
    },

    saveCountUserView() {
      this.showTaskCountLogTable = true;
      let apiClient = apiClientCreator(
        `tasks/stats/views_count/${this.task.id}`
      );
      apiClient.post("");
    }
  },
};
</script>

<style scoped>
.d-none{
  display: none;
}
.content-small {
  font-size: 10pt;
  max-height: 60px;
  /*padding-left: 56px;*/
  width: 100%;
  overflow-x: hidden;
}
.content-small-for-agent {
  font-size: 10pt;
  max-height: 60px;
  padding-left: 37px;
  width: 100%;
  overflow-x: hidden;
}
.content-root {
  font-family: "Montserrat";
  position: relative;
  text-align: left;
}
.content-root-center{
  font-family: "Montserrat";
  position: relative;
  text-align: center;
  align-self: center;
}
/*#main-task-window {*/
/*  position: fixed;*/
/*  height: 884px;*/
/*  z-index: 1;*/
/*  top: 43px;*/
/*  left: 4px;*/
/*  width: 945px;*/
/*  background-color: #f7f7f7;*/
/*  border-radius: 5px;*/
/*  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),*/
/*    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),*/
/*    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);*/
/*}*/

.edit-menu button:hover {
  background: #44a2d2;
  color: white;
}
.reply-table-inner td {
  border-top: 1px solid #dee2e6;
}

.edit-menu button {
  display: block;
  font-size: 8pt;
  font-weight: bold;
  background-color: white;
  color: #2c4762;
  width: 100%;
  height: 20px;
  outline: none;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
  line-height: 8pt;
  border: none;
}

/*
  .popup-content {
    padding: 10px;
    position: absolute;
    top: 24px;
    right: 10px;
    z-index: 10001;
    width: max-content;
    background-color: #fff;
    border: solid 1px #90a4ae;
    border-radius: 5px;

    -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
    box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  }

  .table-responsive {
    margin-bottom: 0px;
    border-radius: 5px;
  }
  */

.content-root-left {
  position: relative;
  text-align: left;
}

.btn-finish {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #4caf50;
  color: white;
  margin: 2px;
}
.btn {
  padding: 1px 2px 1px 2px !important;
}
.btn-finish:hover {
  background: #9e9e9e;
}

.btn-cancel {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #f44336;
  color: white;
  margin: 2px;
}

.btn-cancel:hover {
  background: #9e9e9e;
}

.btn-reply {
  padding: 3px;
  height: 20px;
  line-height: 10px;
  font-size: 8pt;
  margin-left: 5px;
}

.btn-reply-hover {
  background: #9e9e9e;
}

.btn-in-progress {
  padding: 3px;
  border: none;
  border-radius: 3px;
  font-size: 8pt;
  background: #7b1fa2;
  color: white;
  margin: 2px;
}

.btn-in-progress:hover {
  background: #9e9e9e;
}

.new-client-cancel-btn {
  color: red !important;
  margin-left: 5px;
  margin-top: 5px;
}

.new-client-ok-btn {
  color: green !important;
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.edit-text-cancel-btn {
  color: red !important;
  position: absolute;
  right: 10px;
  bottom: 5px;
}

.edit-text-ok-btn {
  color: green !important;
  position: absolute;
  right: 25px;
  bottom: 5px;
}

.edit-reply-cancel-btn {
  color: red !important;
  position: absolute;
  right: 30px;
  bottom: 5px;
}

.edit-reply-ok-btn {
  color: green !important;
  position: absolute;
  right: 45px;
  bottom: 5px;
}

.btns-div {
  position: absolute;
  top: 0px;
  right: -14px;
  padding: 0px;
  display: flex;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 36px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.edit-pencil {
  cursor: pointer;
}

.reply-input-box {
}

.input-box-reply {
  position: absolute;
  top: -323px;
  /*bottom: -509px;*/
  right: -350px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 180%;
  height: auto;
  padding: 10px 10px 28px 10px;
  background-color: #fff;
  /*height: 647px;*/
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.tag-table {
  position: absolute;
  top: 24px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: max-content;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.reply-table {
  position: absolute;
  top: 35px;
  right: -140px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 130%;

  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.reply-table-inner {
  height: auto;
  overflow-x: hidden;
  max-height: 250px;
  font-size: 9pt;
}

.reply-table-bottom {
  position: absolute;
  top: 135px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;

  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.input-box {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;
  padding: 10px 10px 28px 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.content-popup {
  position: absolute;
  bottom: 35px;
  right: 0px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.content-popup-add-reply {
  height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;

  margin-bottom: 5px;

  border: 1px solid #c4c4c4;
  padding: 10px;
  background: #fafafa;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.reply-assignments {
  font-size: 9pt;
  height: auto;
  max-height: 80px;
  width: 100px;
  overflow-x: hidden;
}

.reply-content-td {
  width: 690px;
}

.reply-content {
  font-size: 9pt;
  height: auto;
  max-height: 140px;
  width: 740px;
  overflow-x: hidden;

  word-break: break-all;
  white-space: normal;
}

.reply-date-time {
  text-align: center;
  font-size: 9pt;
}

.reply-user-name {
  text-align: center;
  font-size: 9pt;
  min-width: 100px;
}

.btn-reply-box {
  /*    padding: 3px;
                  height: 20px;
                  line-height: 10px;
                  font-size: 8pt;
                  margin-left: 5px;*/

  margin-top: 3px;
  margin-bottom: 3px;
  white-space: nowrap;
  cursor: pointer;
  vertical-align: middle;
  padding: 2px;
  text-align: center;
  background: #fafafa;
  line-height: 1;
  font-size: 10pt;
  border: 1px solid transparent;
  transition: box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  -webkit-appearance: none;
}

.btn-reply-box:hover {
  background: #44a2d2;
  color: white;
}

.btn-reply-box-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 2px;
  /* position: absolute;
                   right: 10px;
                   bottom: 5px;*/
}

.div-btn-reply-box {
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #c4c4c4;
  padding-left: 3px;
  background: #fafafa;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.toolbar-separator {
  border-left: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  margin-top: 0;
  margin-right: 2px;
  margin-left: 2px;
}

.task-menu-btn {
  font-size: 13pt;
  height: 23px;
  font-weight: lighter;
  cursor: pointer;
  vertical-align: middle;
  color: #2c4762;
  background: white;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease;
}

.task-menu-btn:hover {
  color: white;
  background: #44a2d2;
}

.task-menu-btn-hover {
  font-size: 12pt;
  cursor: pointer;
  vertical-align: middle;
  color: white;
  background: #44a2d2;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease;
}

.read-it-btn {
  fill: #2c4762;
  cursor: pointer;
  margin-right: 3px;
  transition: background 0.2s ease, color 0.2s ease;
  vertical-align: middle;
}

.read-it-btn:hover {
  fill: #44a2d2;
  margin-right: 3px;
}

.edit-menu {
  background-color: #f1f1f1;
}

.dropdown-menu {
  width: max-content;
  min-width: 80px !important;
  padding: 2px;
  border: 1px solid #c4c4c4;
}

/* Change background color of buttons on hover */

/* Create an active/current "tab button" class */
/*
          .edit-menu button.active {
            border-bottom: 2px solid #44a2d2 !important;
            background: #44a2d2;
            color: white;
            width: 105%;
            border-bottom-right-radius: 5px;
            border-top-right-radius: 5px;
          }
          */

.edit-reply-btn-div {
  display: flex;
  vertical-align: center;
}

.edit-reply-btn-edit {
  margin-right: 25px;

  cursor: pointer;
}

#reply-editor {
  height: 609px;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2222222222222222222222222222222; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}

.waitingToBeConfirmed {
  background-color: #ff8c68;
}

.select-user {
  background-color: #5da4db;
}

.transfer-to-users-box {
  position: absolute;
  top: 361px;
  right: 170px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.stay-open-transfer {
  overflow-y: scroll;
  display: block !important;
  max-height: 343px;
  top: -101px;
  position: absolute;
  left: -43px;
  width: 200px;
  padding: 10px;
}

.pointer {
  cursor: pointer;
}

.input-main {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
}

.item-text {
  margin-left: 5px;
}

.m-b-3px {
  margin-bottom: 3px;
}
.btn-tag {
  margin-left: 3px;
  border-radius: 4px;
  font-size: 12px;
}
.btn-tag-less-then-three {
  margin-left: 3px;
  border-radius: 4px;
  font-size: 12px;
  padding-bottom: -4px !important;
}
.btn-tag-for-more-then-three {
  margin-left: 1px;
  border-radius: 4px;
  font-size: 10px;
  /*width: 102%;*/
  width: 40%;
}
.btn:active,
.btn:target,
.btn:focus {
  border-radius: 20px;
  border: none;
  outline: none;
}
.content-preview,
.tags-btn {
  /*float: right;*/
  /*width: 20%;*/
  overflow: hidden;
  padding-left: 10px;
  /*width: auto !important;*/
  /*width: 480px !important;*/
  /*width: 445px !important;*/
  margin-left: 25px;
}
.content-preview-for-agent {
  text-align: center;
  overflow: hidden;
}

.tags-btn-for-agent {
  padding-left: 15px;
  overflow: hidden;
}
.read-btn {
  font-size: 12px;
}
.fasMore {
  /*color: #d58512;*/
  padding-left: 248px;
  padding-top: 2px;
  cursor: pointer;
  max-width: fit-content;
}
.forTheRestCat {
  z-index: 10001;
  display: flex;
  flex-direction: column;
  padding: 5px;
  justify-content: center;
  position: absolute;
  top: 24px;
  left: 550px;
  /*background-color: white;*/

  border-radius: 5px;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.allRestCat {
  /*border-radius: 20px;*/
  /*margin-top: 3px;*/
  /*color: #fff;*/
  /*background-color: #f0ad4e;*/
  /*border-color: #eea236;*/
  /*font-size: 11px;*/
  margin-left: 3px;
  border-radius: 4px;
  font-size: 12px;
  background-color: #f0ad4e;
  color: #fff;
  border-radius: 3px;
  margin-top: 3px;
  border-color: #eea236;
}
.row {
  margin-right: 5px;
  margin-left: -26px;
}
/*
  .row {
    margin-right: -63px;
    margin-left: 2px;
  }
  */
.row-for-agent {
  margin-right: -36px;
  margin-left: 51px;
}
.rowShowAll {
  margin-right: -40px;
  margin-left: 37px;
}
.override {
  padding-left: 0;
  padding-right: 0;
}

.btn-tag-for-more-then-three .itemBtn {
  margin-bottom: 2px !important;

  font-size: 10px;
}
.task-btn-open-wrapper,
.tags-btn {
  padding-left: 3px;
  padding-right: 3px;
  /*max-width: 494px;*/
  white-space: nowrap;
  /*min-width: 370px;*/
  width: 200px;
}

.tags-btn {
  padding-left: 3px;
  padding-right: 3px;
  /*max-width: 494px;*/
  white-space: nowrap;
  /*min-width: 370px;*/
  width: 370px;
}
.task-preview-popup {
  /*max-height: 300px;*/
  background-color: white;
  /*width: 500px;*/
  min-width: 500px;
  max-width: 600px;
  position: absolute;
  /*left: 339px;*/
  left: 777px;
  z-index: 2;
  /*border: 1px dotted red;*/
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  top: -261px;
  padding: 10px;
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/*.task-content-preview {*/
/*  border-radius: 1px 3px 3px 3px;*/
/*  border: 1px solid #cfd8dc;*/
/*  border-top-color: #fff;*/
/*  background-color: #ebe8e5;*/
/*  background-color: #fff;*/
/*  padding: 18px;*/
/*  !* -webkit-box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15); *!*/
/*  !* box-shadow: 0px 0 0px -2px rgba(0, 0, 0, 0.15); *!*/
/*  overflow: auto;*/
/*  !* width: 1026px; *!*/
/*  max-width: 1083px;*/
/*  width: -webkit-max-content;*/
/*  width: -moz-max-content;*/
/*  width: max-content;*/
/*  height: 595px;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  padding-left: 0px;*/
/*  padding-right: 0px;*/
/*  border-style: none;*/
/*  max-height: 290px;*/
/*  overflow: hidden;*/
/*}*/
.task-content-preview {
  border-radius: 1px 3px 3px 3px;
  border: 1px solid #cfd8dc;
  border-top-color: #fff;
  background-color: #ebe8e5;
  background-color: #fff;
  padding: 18px;
  /* -webkit-box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15); */
  /* box-shadow: 0px 0 0px -2px rgba(0, 0, 0, 0.15); */
  overflow: auto;
  /* width: 1026px; */
  /*max-width: 1083px;*/
  max-width: 600px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  height: 595px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  padding-left: 0px;
  padding-right: 0px;
  border-style: none;
  /*max-height: 290px;*/
  overflow: hidden;
}
.f-item {
  flex: 1;
  overflow-y: auto;
  min-width: 522px;
}
.pull-left {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.replies-preview {
  margin-right: 20px;
}
.replies-table {
  width: 100%;
}
.replies-table th {
  padding-left: 5px;
}
.replies-table td {
  padding: 2px 8px;
  font-size: 12px;
}
div.task-preview .quillWrapper {
  height: 100%;
  /*margin: 9px;*/
  border-radius: 5px;
  overflow: hidden;
}
.task-preview {
  /*height: calc(100% - 30px);*/

  /*border: 1px solid #cccccc;*/
  /*padding: 10px;*/
  background-color: #f1f1f1;
  margin-top: 20px;
  margin-right: 20px;
}
.task-preview img {
  height: 200px;
}
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  /*border-bottom-width: 2px;*/
  padding: 4px;
}
.task-btn-open-wrapper {
  float: right;
  width: 200px;
}
.img-editor {
  border-radius: 5px;
  cursor: pointer !important;
  transition: 0.3s;
}
.modal-content {
  margin-top: 10% !important;
  transform: scale(2.5) !important;
  /*transition: transform 10000ms ease-in-out!important;*/
}
/*.bold-tilte{*/
/*  font-weight: 800;*/
/*}*/
.carousel-control {
  width: 5% !important;
}
.carousel-inner {
  margin-left: 22px !important;
  margin-right: 22px !important;
}
.carousel-control.left,
.carousel-control.right {
  background-image: none;
}
</style>
